import api from './api';

export interface Area {
  id: string;
  nome: string;
  sigla: string;
  descricao?: string;
  usuarioId?: string;
  diretoriaId?: string;
  diretoriaNome: string;
  usuarioNome: string;
}

export const getAllAreas = () => api.get<Area[]>('areas');
export const getAreasByDiretoria = (diretoriaId: any) => api.get<Area[]>(`areas/diretoria/${diretoriaId}`);
export const createArea = (area: Area) => api.post<Area>('areas', area);
export const updateArea = (area: Area) => api.put<Area>(`areas/${area.id}`, area);
export const deleteArea = (id: string) => api.delete(`areas/${id}`);
export const getAllAreasByDiretoriaOptions = (diretoriaId: any) =>
  getAreasByDiretoria(diretoriaId).then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));
export const getAllAreasOptions = () =>
  getAllAreas().then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));
